module.exports = __webpack_public_path__ + "img/new_index_cases27.1e5e3100.png";